/** Cache tags for reports, one per report resource (registered in apiSlice's tagTypes). */
export enum ReportTags {
  DispatchReport = "DispatchReport",
  InventoryReport = "InventoryReport",
  ReceiptReport = "ReceiptReport",
  AdjustmentReport = "AdjustmentReport",
  ToeReport = "ToeReport",
  EstoreReport = "EstoreReport",
  TollReport = "TollReport",
  ReportUpload = "ReportUpload",
  ReportSnapshot = "ReportSnapshot",
}
